"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableAreaStyled = exports.SpeechBubbleStyled = exports.SpeechBubbleTailPolygon = exports.SpeechBubbleTail = exports.Icon = exports.Text = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("../../hotspot.constants");

var _hotspotGlobal = require("../../hotspot.global.styles");

var _hotspot2 = _interopRequireDefault(require("../../hotspot.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var transition = 'all 200ms ease';

var Text = _styledComponents.default.span.withConfig({
  displayName: "speech-bubblestyles__Text",
  componentId: "ea4ge5-0"
})(["color:", ";flex:1;padding:0 1em;transition:", ";white-space:nowrap;"], function (_ref) {
  var color = _ref.color;
  return color;
}, transition);

exports.Text = Text;

var Icon = _styledComponents.default.svg.attrs({
  focusable: false
}).withConfig({
  displayName: "speech-bubblestyles__Icon",
  componentId: "ea4ge5-1"
})(["fill:", ";height:0.7em;stroke:", ";transition:", ";"], function (_ref2) {
  var iconColor = _ref2.iconColor;
  return iconColor;
}, function (_ref3) {
  var iconColor = _ref3.iconColor;
  return iconColor;
}, transition);

exports.Icon = Icon;

var SpeechBubbleTail = _styledComponents.default.svg.attrs({
  focusable: false
}).withConfig({
  displayName: "speech-bubblestyles__SpeechBubbleTail",
  componentId: "ea4ge5-2"
})(["top:calc(100% - 1px);height:0.7em;position:absolute;width:1.4em;"]);

exports.SpeechBubbleTail = SpeechBubbleTail;

var SpeechBubbleTailPolygon = _styledComponents.default.polygon.withConfig({
  displayName: "speech-bubblestyles__SpeechBubbleTailPolygon",
  componentId: "ea4ge5-3"
})(["fill:", ";transition:", ";"], function (_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return backgroundColor;
}, transition);

exports.SpeechBubbleTailPolygon = SpeechBubbleTailPolygon;

var SpeechBubbleStyled = _styledComponents.default.div.attrs(function (_ref5) {
  var iconPosition = _ref5.iconPosition;
  return {
    style: {
      left: "".concat(iconPosition.left, "%"),
      top: "".concat(iconPosition.top, "%")
    }
  };
}).withConfig({
  displayName: "speech-bubblestyles__SpeechBubbleStyled",
  componentId: "ea4ge5-4"
})(["display:flex;align-items:center;justify-content:space-between;background:", ";font-family:Poppins,sans-serif;font-size:2em;font-weight:bold;text-align:left;letter-spacing:0.05em;height:2.5em;padding:0 1em;max-width:80em;border-radius:3em;position:absolute;transform:", ";transition:", ";", ""], function (_ref6) {
  var config = _ref6.config;
  return config.backgroundColor;
}, _hotspotGlobal.translateXY, transition, function (_ref7) {
  var left = _ref7.iconPosition.left;
  var childStyles;

  if (left < 38) {
    childStyles = "\n        ".concat(Text, " {\n          order: 1;\n        }\n\n        ").concat(Icon, " {\n          order: 2;\n          margin-right: 0.5em;\n        }\n\n        ").concat(SpeechBubbleTail, " {\n          right: 0.5em;\n          transform: scaleX(-1);\n        } \n\n      ");
  } else {
    childStyles = "\n        ".concat(Text, " {\n          order: 2;\n        }\n\n        ").concat(Icon, " {\n          order: 1;\n          margin-left: 0.5em;\n        }\n\n        ").concat(SpeechBubbleTail, " {\n          left: 0.5em;\n        } \n      ");
  }

  return childStyles;
});

exports.SpeechBubbleStyled = SpeechBubbleStyled;

var hoverState = function hoverState(hoverStyle) {
  return "\n  ".concat(SpeechBubbleStyled, " {\n    background: ").concat(hoverStyle.backgroundColor, ";\n  }\n\n  ").concat(Text, " {\n    color: ").concat(hoverStyle.color, ";\n  }\n\n  ").concat(Icon, " {\n    fill: ").concat(hoverStyle.iconColor, ";\n    stroke: ").concat(hoverStyle.iconColor, ";\n  }\n\n  ").concat(SpeechBubbleTailPolygon, " {\n    fill: ").concat(hoverStyle.backgroundColor, ";\n  }\n");
};

var ClickableAreaStyled = (0, _styledComponents.default)(_hotspot2.default).withConfig({
  displayName: "speech-bubblestyles__ClickableAreaStyled",
  componentId: "ea4ge5-5"
})(["", ""], function (_ref8) {
  var disableHover = _ref8.disableHover;
  return !disableHover && (0, _styledComponents.css)(["&:hover,&", "{", ";}", ""], _hotspot.focusVisible, function (_ref9) {
    var hoverStyle = _ref9.hoverStyle;
    return hoverState(hoverStyle);
  }, function (_ref10) {
    var hoverStyle = _ref10.hoverStyle,
        previewHoverState = _ref10.previewHoverState;
    return previewHoverState && hoverState(hoverStyle);
  });
});
exports.ClickableAreaStyled = ClickableAreaStyled;